module.exports = __webpack_public_path__ + "img/rang10.c81238ff.png";